
import { getSchema } from '../../decorators/utilities/get.merge.schema';
import { MergeField } from '../../decorators/decorators/merge.field';
import { MergeSchema } from '../../decorators/decorators/merge.schema';
import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { StageItemMergeData } from './stage.items.merge.data';

@MergeSchema({
    entity: ActivityEntityName.Code,
    name: 'JobItemMergeDataSchema',
})
export class JobItemMergeData extends StageItemMergeData {

    @MergeField()
    technician: string;

    @MergeField()
    stageNumber: string;

    @MergeField()
    stageName: string;
}

export const JobItemMergeDataSchema = getSchema(JobItemMergeData);

